import { render, staticRenderFns } from "./addPageProPay.vue?vue&type=template&id=4b097d92&scoped=true&"
import script from "./addPageProPay.vue?vue&type=script&lang=js&"
export * from "./addPageProPay.vue?vue&type=script&lang=js&"
import style0 from "./addPageProPay.vue?vue&type=style&index=0&id=4b097d92&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b097d92",
  null
  
)

export default component.exports